import { Component } from '@angular/core';
import { BrowseUserPlaylistsComponent } from './BrowseUserPlaylists.Component';

@Component({
	selector: 'browse-user-playlists-tiles',
	templateUrl: './BrowseUserPlaylistsTiles.Component.html'
})
export class BrowseUserPlaylistsTilesComponent extends BrowseUserPlaylistsComponent {}
